import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const PopupBanner = ({ onClose }) => {
  const { popup } = useSelector((state) => state.home);
  const { data: popupData, loading, error } = popup;
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // Check if the popup has already been shown in this session
    const hasOpened = sessionStorage.getItem('hasOpenedPopup');

    if (!hasOpened) {
      const delay = 1000; // Delay in milliseconds (e.g., 3 seconds)

      const timer = setTimeout(() => {
        setIsVisible(true);
        sessionStorage.setItem('hasOpenedPopup', 'true'); // Mark as opened
      }, delay);

      return () => clearTimeout(timer); // Cleanup on unmount
    }
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 500); // Match the animation duration
  };

  if (loading) {
    return (
      <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white rounded-lg shadow-xl relative p-4">
          <p>Loading popup image...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white rounded-lg shadow-xl relative p-4">
          <p className="text-red-500">Error loading popup: {error}</p>
        </div>
      </div>
    );
  }

  if (!popupData) {
    return null; // Or a message like "No popup available"
  }

  return (
    isVisible && ( // Only render if isVisible is true
      <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div
          className={`bg-white rounded-lg shadow-xl relative transform transition-transform duration-500 ease-out ${
            isVisible ? 'scale-100' : 'scale-0'
          } ${isClosing ? 'translate-y-full opacity-0' : ''} w-11/12 max-w-md`} // Adjusted max-width for responsiveness
          style={{ maxHeight: '90vh' }} // Limit overall max height
        >
          {/* Close Button */}
          <div className="absolute -top-8 -right-8 md:-top-10 md:-right-10"> {/* Adjusted positioning for larger screens */}
            <button
              className="absolute top-2 right-4 text-gray-600 hover:text-gray-800 focus:outline-none"
              onClick={handleClose}
              style={{
                backgroundColor: 'white',
                borderRadius: '50%',
                width: '24px',
                height: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0,
                border: 'none',
                cursor: 'pointer',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="currentColor"
                viewBox="0 0 24 24"
                stroke="currentColor"
                style={{ color: 'red' }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Image */}
          <img
            src={popupData.image_url}
            alt="Popup Banner"
            className="w-full h-auto rounded-lg block m-auto"
            style={{ maxHeight: '80vh', maxWidth: '100%' }} // Limit the maximum height and width of the image
          />
        </div>
      </div>
    )
  );
};

export default PopupBanner;